/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/SubmitAction",
  isSubmitting
  
}) {
let txCardFieldDefinitionIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 size="normal"
 type="primary"
 marginLeft={dtSpaceXs}
 onClick={onClick}
 data="tx_card_field_definition"
 disabled={txCardFieldDefinitionIsSubmittingData}
 text="Save"
/>
{children}
</React.Fragment>)
}